import type {ClientProfile} from '../types';

// Colors sourced from official Salam brand artwork (wordmark + leaf logo).
// Primary palette: #0F4F4A Dark Teal (wordmark) | #00C82C Salam Green (leaf accent)
export const salamProfile: ClientProfile = {
  clientId: 'salam',
  theme: {
    appTitle: 'Salam Dashboard',
    brandName: 'Salam',
    logoUrl: '/assets/clients/salam/logo.png',
    loginLogoUrl: '/assets/clients/salam/logo-light.png',
    loginBackgroundUrl: '/assets/clients/salam/login-background.png',
    primaryColor: '#0F4F4A',
    designSystem: {
      colors: {
        primary:   '#0F4F4A', // Dark Teal — wordmark, brand primary
        secondary: '#00C82C', // Salam Green — leaf accent
        grayText:  '#0F4F4A',
        grayUnit:  '#4A6B6A',
        error:     '#DC2626',
        warning:   '#D97706',
        success:   '#16A34A',
      },
      typography: { fontFamily: 'Tajawal', fontFamilyHeading: 'Tajawal' },
      themeClass: 'theme-salam'
    }
  },
  // Salam: same module set as GO Telecom — stores + products + inventory + visits + marketer tracking.
  // No sales, invoices, payments, or anything billing-related.
  enabledModules: [
    'dashboard',
    'map',
    'stores-map',
    'stores',
    'store-deliveries',
    'visits',
    'products',
    'add-stock',
    'marketers',
    'marketer-tracking',
    'users',
    'checklists',
  ],
  defaultLandingPath: '/dashboard'
};
